import { fork, all } from 'redux-saga/effects';
import { saga as iddSaga } from './IDD';
import { saga as roamingSaga } from './Roaming';

export default function*(): Generator<*, *, *> {
  yield all([fork(iddSaga), fork(roamingSaga)]);
}
